<template lang="pug">
  .table-responsive
    table#tbitemsIn.table.is-striped.is-fullwidth
      thead
        tr
          th Ubicación
          th Fecha Reg.
          th Movimientos
          th Cant.
          th Precio U.
          th Proveedor
          th Factura
      tbody
        tr(v-for="(data, index) in consumibles" :key="data.id")
          td
            .control
              .tags.has-addons
                span.tag.is-black
                  | {{ data.ubicacion }}
                span.tag.is-warning
                  | {{ data.oficina }}
          td
            span.tag
              | {{ data.fecha_Alta}} 
          td(v-if="data.tipo == 1")
            b
              small 
                | Entrega:&nbsp
            span.tag.is-info {{ data.entrega }}
            | &nbsp
            a.button.is-small.is-rounded(:class="data.firma_entrega === ''? 'is-text': 'is-black'" @click="firmarSalida(data, 1)")
              i.fas.fa-signature
            br
            b
              small
                | Traslada:&nbsp
            span.tag.is-primary {{ data.traslada }}
            | &nbsp
            a.button.is-small.is-rounded(:class="data.firma_traslada === ''? 'is-text': 'is-black'" @click="firmarSalida(data, 2)")
              i.fas.fa-signature
            br
            b
              small
                | Recibe:&nbsp
            span.tag.is-black {{ data.recibe }}
            | &nbsp
            a.button.is-small.is-rounded(:class="data.firma_recibe === ''? 'is-text': 'is-black'" @click="firmarSalida(data,3)")
              i.fas.fa-signature
          td(v-else)
            span.tag.is-black
              | Compra
            | &nbsp
            span.tag(v-show="data.partida !== ''")
              | {{ data.partida }}
            | &nbsp
            span.tag(v-show="data.localizacion !== ''")
              | {{ data.localizacion }}
          td
            a.button.is-text.is-small.is-rounded(v-show="data.tipo == 1" @click="printSalida(data)")
              i.fas.fa-print
            span.tag.is-black
              | {{ data.cantidad }}
          td 
            span.tag.is-black(v-show="data.tipo == 0") {{ data.moneda == 1 ? `$ ${data.precioUnitario}`: `US$ ${data.precioUnitario}`}}
          td
            span.tag(v-show="data.proveedor !== ''")
              | {{data.proveedor}}
          td
            span.tag(v-show="data.factura !== ''")
              | {{data.factura}}
</template>

<script>
  export default {
    name: 'TbConsumiblesIn',
    props: {
      consumibles: {
        type: Array,
        default: []
      },
    },
    methods: {
      firmarSalida (data, momento) {
        if (this.permisos.inventarios == 6) {
          return
        }
        let myObj = this.agregarMomento(data, momento)
        this.$emit('firmarSalida', myObj)
      },
      agregarMomento(data, momento) {
        return {
          ...data,
          cantidad_e: parseInt(data.cantidad_e),
          cantidad_t: parseInt(data.cantidad_t),
          cantidad_r: parseInt(data.cantidad_r),
          id: parseInt(data.id),
          id_salida: parseInt(data.id_salida),
          estado: momento
        }
      },
      printSalida (mov) {
        const currentUrl = window.location.hostname
        let link = `https://${currentUrl}/servidores/reportes/inventarios/salidaCons_I.php?id=${mov.id_salida}`
        open(link, '_blank')
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/TbConsumiblesIn.vue